import React, {useState} from "react";
import "./index.scss";
import {CardCvcElement, CardExpiryElement, CardNumberElement} from "@stripe/react-stripe-js";
import {__} from "services/i18n";
import Text from "features/components/text";

export const PaymentCard = (props) => {
    const {onChange} = props;

    const [number, setNumber] = useState({complete: false, empty: true});
    const [expiry, setExpiry] = useState({complete: false, empty: true});
    const [cvc, setCvc] = useState({complete: false, empty: true});


    React.useEffect(() => {
        onChange(number.complete && expiry.complete && cvc.complete);
    }, [number, expiry, cvc, onChange]);

    const style = {
        style: {
            iconColor: '#3c3f42',
            fontFamily: 'Noto Sans, sans-serif',
            padding: '16px',
            boxSizing: 'border-box',
            color: '#3c3f42'
        }
    }

    return <>
        <div className={`payment-field ${!number.empty ? "has-value" : ""}`}>
            <span className="placeholder">{__("text-fields.card-number.placeholder")}</span>
            <CardNumberElement
                id={"stripe-element"}
                options={style}
                onChange={(props) => {
                    setNumber(props);
                }}
            />
            {number.error && <Text color={"danger"} size={16}>{number.error.message}</Text>}
        </div>
        <div className={`payment-field ${!expiry.empty ? "has-value" : ""}`}>
            <span className="placeholder">{__("text-fields.card-exp.placeholder")}</span>
            <CardExpiryElement
                id={"stripe-element"}
                options={style}
                onChange={(props) => {
                    setExpiry(props);
                }}
            />
            {expiry.error && <Text color={"danger"} size={16}>{expiry.error.message}</Text>}
        </div>
        <div className={`payment-field ${!cvc.empty ? "has-value" : ""}`}>
            <span className="placeholder">{__("text-fields.card-cvv.placeholder")}</span>
            <CardCvcElement
                id={"stripe-element"}
                options={style}
                onChange={(props) => {
                    setCvc(props);
                }}
            />
            {cvc.error && <Text color={"danger"} size={16}>{cvc.error.message}</Text>}
        </div>
    </>

    /*return <CardElement
        onChange={(props) => {
            onChange(props.complete);
        }}
        options={{
            style: {
                base:{
                    iconColor: '#3c3f42',
                    fontFamily: 'Noto Sans, sans-serif'
                }
            }
        }}
    />;*/
}